import React from 'react';
import { PatchNoteType } from '@colonist/types';
import styles from './PatchNoteTypeBadge.module.scss';
const TYPE_BADGE_CLASS = {
    [PatchNoteType.Feature]: styles.feature,
    [PatchNoteType.Update]: styles.update,
    [PatchNoteType.Blog]: styles.blog,
    [PatchNoteType.Fix]: styles.fix,
    [PatchNoteType.Youtube]: styles.youtube
};
export function PatchNoteTypeBadge({ type, link, onExternalClick }) {
    const baseClass = `${styles.badge} ${TYPE_BADGE_CLASS[type]}`;
    if (!link) return /*#__PURE__*/ React.createElement("span", {
        className: baseClass
    }, type.toString());
    return /*#__PURE__*/ React.createElement("span", {
        className: `${baseClass} ${styles.clickable}`,
        onClick: ()=>onExternalClick(link)
    }, type.toString());
}
